import cn from 'classnames';
import React from 'react';
import Button, { ButtonType } from '../Button';
import { Container } from '../Container';
import { IconName } from '../Icon';

interface CTAFooterProps {
  primaryCTACopy: string;
  secondaryCTACopy?: string;
  primaryIconName?: IconName;
  secondaryIconName?: IconName;
  primaryCTAOnClick: () => void;
  secondaryCTAOnClick?: () => void;
}

export const CTAFooter: React.FC<CTAFooterProps> = ({
  primaryCTACopy,
  secondaryCTACopy,
  primaryIconName,
  secondaryIconName,
  primaryCTAOnClick,
  secondaryCTAOnClick,
}) => {
  const hasTwoCTAs = Boolean(secondaryCTACopy && secondaryCTAOnClick);

  return (
    <div className='border-t border-t-eggplant-50 bg-white shadow-xl'>
      <Container>
        <div
          className={cn('flex items-center py-3', {
            'justify-between': hasTwoCTAs,
            'justify-center': !hasTwoCTAs,
          })}>
          {secondaryCTACopy && secondaryCTAOnClick && (
            <Button buttonType={ButtonType.Secondary} onClick={secondaryCTAOnClick} iconName={secondaryIconName}>
              {secondaryCTACopy}
            </Button>
          )}
          <Button buttonType={ButtonType.Primary} onClick={primaryCTAOnClick} iconName={primaryIconName}>
            {primaryCTACopy}
          </Button>
        </div>
      </Container>
    </div>
  );
};
